export default {
  interviewAnswers: [],
  interviewAnswer: undefined,
};
